import { makeAutoObservable } from 'mobx'
import { injectable, inject, decorate } from '@evertel/di'
import { DocumentSchemaStore } from '../../store'
import { APIDataDocumentSchema } from '@evertel/types'
import { Api } from '@evertel/api'


class DepartmentDocumentSchemasController {
    departmentId = 0

    constructor(
        private documentSchemaStore: DocumentSchemaStore,
        private api: Api
    ) {
        makeAutoObservable(this)
    }

    init = async (departmentId: number) => {
        this.departmentId = departmentId

        await this.fetchDepartmentDocumentSchemas()
    }

    fetchDepartmentDocumentSchemas = async (): Promise<APIDataDocumentSchema[]> => {
        if (!this.departmentId) return []

        const schemas = await this.api.Routes.Department.getDocumentSchemas(this.departmentId, {
            order: 'name ASC',
            include: ['categories']
        })

        if (schemas?.length) this.documentSchemaStore.update(schemas)

        return schemas
    }

    get documentSchemaIds() {
        return this.documentSchemaStore.find(d => d.departmentId === this.departmentId).map(d => d.id)
    }

    get documentSchemas() {
        return this.documentSchemaStore.findByIds(this.documentSchemaIds)
    }

    get enabledDocumentSchemas() {
        return this.documentSchemas.filter(d => d.isEnabled === true)
    }

    get disabledDocumentSchemas() {
        return this.documentSchemas.filter(d => d.isEnabled === false)
    }

    get uncategorizedDocumentSchemas() {
        return this.enabledDocumentSchemas.filter(d => !d.categories || d.categories.length === 0)
    }

    schemasForCategory(categoryId: number): APIDataDocumentSchema[] {
        return this.enabledDocumentSchemas.filter(s =>
            s.categories?.some(c => c.id === categoryId)
        )
    }
}

decorate(injectable(), DepartmentDocumentSchemasController)
decorate(inject(DocumentSchemaStore), DepartmentDocumentSchemasController, 0)
decorate(inject(Api), DepartmentDocumentSchemasController, 1)

export { DepartmentDocumentSchemasController }
